import React from "react";

import * as S from "./styled";

const ClaimedDealHDPMessage = () => (
  <S.Container>
    <S.CheckMark />
    <div>You’ve claimed this deal and are displayed as the buyer’s agent</div>
  </S.Container>
);

export default ClaimedDealHDPMessage;
